module.exports = require('./lib/ReactWithAddons');



//////////////////
// WEBPACK FOOTER
// ./~/react/addons.js
// module id = 5
// module chunks = 0